import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const Header = styled.div`
  width: 100%;
  padding: 24px 36px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
`

export const Column = styled.div`
  width: fit-content;
  max-width: 265px;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.01em;
  color: #000000;
`

export const ColumnWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-left: 24px;
  justify-content: flex-start;
  column-gap: 32px;
`

export const Title = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.035em;
  color: #717171;
`

export const TitleURL = styled.a`
  font-weight: 700;
  font-size: 16.0588px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #000000;
`

export const ChatWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 24px 80px;
  row-gap: 24px;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  overflow: scroll;
`

export const InputWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  padding: 12px 17px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
`

export const Button = styled.button`
  background-color: #000000;
  border: 2px solid #ffffff;
  color: #ffffff;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  padding: 12px 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 43px;
`

export const Input = styled.input`
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  color: #000000b2;
  background: #ffffff;
  border: 1px solid transparent;
  width: 60%;
  &:focus {
    border: 1px solid transparent;
  }
  &:focus-visible {
    border: 1px solid transparent;
    outline: 1px solid transparent;
  }
`

export const MessagesWrapper = styled.div`
  width: calc(100% - 48px);
  height: fit-content;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 80px;
  left: 24px;
`

export const DeclineButton = styled.button`
  padding: 5px 30px 5px 36px;
  width: fit-content;
  height: 52px;
  border: 2px solid #ff4545;
  background: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #ff4545;
  margin-right: 18px;
  cursor: pointer;
`

export const RegularButton = styled.button`
  padding: 5px 30px 5px 36px;
  width: fit-content;
  height: 52px;
  background: #000000;
  border: 2px solid #000000;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
`
